import React, { useContext } from 'react';
import ProductPageContext from '../../contexts/ProductPageContext';
import TmntHtml from '../../tools/TmntHtml';

export default function SizeMessaging() {
  const ProductPageState = useContext(ProductPageContext);

  const {
    tmntData,
    collectionData,
  } = ProductPageState;

  const {
    brand, sizeChartType,
  } = collectionData;

  const isChartSupported = () => {
    const chartsToSupport = ['SIZECHART_ST-BOTTOMS-U', 'SIZECHART_ST-BTMSALPHA-M', 'SIZECHART_ST-TOPS-U'];
    return sizeChartType && chartsToSupport.indexOf(sizeChartType) > -1;
  };

  const handleMessagingContent = () => {
    if (sizeChartType === 'SIZECHART_ST-BTMSALPHA-M') {
      return tmntData.sizeGuideMessagingGuys.value;
    }
    return tmntData.sizeGuideMessagingGirls.value;
  };

  if (!isChartSupported()) return null;

  return (
    <div className="size-messaging-section" data-product-brand={brand}>
      <p className="size-messaging-section__header">{tmntData.sizeGuideHeader.value}</p>
      <p className="size-messaging-secton__subtitle">{tmntData.sizeGuideSubtitle.value}</p>
      <div className="size-messaging-section__body">
        <TmntHtml value={handleMessagingContent()} />
      </div>
    </div>
  );
}
